// "This is not a live ballot" — the band, full-bleed, top and foot.
//
// The mode is carried through the count and out into the result on purpose
// (@cca/decides-count's BallotMode: "so a rehearsal banner is not optional
// decoration"). A results sheet is the screen most likely to be screenshotted
// and forwarded, so the band is full-bleed rather than inside the column, and it
// is repeated at the foot: a long sheet scrolls the top one out of sight, and
// what is left on screen is a page of tallies with nothing saying they are
// invented.
//
// It renders NOTHING on a live ballot. A live band saying "live" would be
// chrome; the band exists to contradict the page, not to label it.

import type { JSX } from 'react';
import type { BallotMode } from '@cca/decides-count';
import { MODE_BAND_COPY } from './view';

interface ModeBandProps {
  mode: BallotMode;
  /**
   * The repeat at the foot of the sheet. Visually identical, and hidden from
   * assistive technology: the sentence is load-bearing where it is READ FIRST,
   * and announcing the same clause twice on one page is noise, not emphasis.
   */
  repeat?: boolean;
}

export function ModeBand({ mode, repeat = false }: ModeBandProps): JSX.Element | null {
  if (mode === 'live') return null;
  const copy = MODE_BAND_COPY[mode];

  return (
    <div className="result-mode-band" aria-hidden={repeat ? true : undefined}>
      <p className="result-mode-band-text">
        <strong>{copy.label}.</strong> {copy.sentence}
      </p>
    </div>
  );
}
